/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanyCreditsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get current credit balance for the company
   * @returns any Credit balance retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsBalance(): CancelablePromise<{
    /**
     * Company credit balance
     */
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/balance',
      errors: {
        500: `Internal server error`,
      },
    });
  }

  /**
   * Check if company is gated from consuming credits
   * @returns any Gate check result
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsGateCheck(): CancelablePromise<{
    data?: {
      /**
       * Whether the company is gated
       */
      gated?: boolean;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/gateCheck',
      errors: {
        500: `Internal server error`,
      },
    });
  }

  /**
   * Check if a company is gated from a specific product (system only)
   * @param companyUuid Company UUID to check
   * @param product Product to check gating for (e.g. ANNA, CUE)
   * @returns any Product gate check result
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsProductGateCheck(
    companyUuid: string,
    product: 'ANNA' | 'SAM' | 'CUE' | 'EMMA' | 'SHARED_POOL',
  ): CancelablePromise<{
    data?: {
      /**
       * Whether the company is gated for this product
       */
      gated?: boolean;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/{companyUuid}/productGateCheck/{product}',
      path: {
        'companyUuid': companyUuid,
        'product': product,
      },
      errors: {
        400: `Bad request — unsupported product`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Create a Stripe PaymentIntent for credit pack purchase
   * @param requestBody
   * @returns any Payment intent created successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompanyCreditsCreatePaymentIntent(
    requestBody?: {
      /**
       * Credit pack SKU to purchase
       */
      packSku: '100' | '900' | '1500' | 'debug_2';
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Stripe client secret for payment confirmation
       */
      clientSecret?: string;
      /**
       * Stripe customer session client secret for PaymentElement saved card display
       */
      customerSessionClientSecret?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companyCredits/createPaymentIntent',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - invalid pack SKU`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Purchase a credit pack for an invoice-billed company (no card required)
   * @param requestBody
   * @returns any Credits added; order queued for invoice reconciliation
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompanyCreditsPurchasePackInvoiced(
    requestBody: {
      /**
       * Credit pack SKU to purchase
       */
      packSku: '100' | '900' | '1500' | 'debug_2';
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Number of credits added to the balance
       */
      creditsAdded?: number;
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companyCredits/purchasePackInvoiced',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request — invalid pack SKU`,
        403: `Forbidden — company is not on invoiced billing`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Confirm a completed Stripe payment and process credits and invoice
   * @param requestBody
   * @returns any Payment confirmed and credits added
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompanyCreditsConfirmPayment(
    requestBody?: {
      /**
       * The Stripe PaymentIntent ID to confirm
       */
      paymentIntentId: string;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Number of credits added
       */
      creditsAdded?: number;
      /**
       * True if the payment was already processed
       */
      alreadyProcessed?: boolean;
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companyCredits/confirmPayment',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - missing ID or payment not succeeded`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Get allow overages setting for the company
   * @returns any Allow overages setting retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsAllowOverages(): CancelablePromise<{
    data?: {
      /**
       * Whether the company allows credit overages
       */
      allowOverages?: boolean;
      /**
       * Maximum credits the company can go negative. Null = unlimited.
       */
      maxOveragesCredits?: number | null;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/allowOverages',
      errors: {
        403: `Feature not enabled for this company`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Enable or disable allow overages for the company
   * @param requestBody
   * @returns any Allow overages setting updated successfully
   * @throws ApiError
   */
  public putApiServiceorganizationsProcessesCompanyCreditsAllowOverages(
    requestBody?: {
      /**
       * Whether to allow the company to exceed 0 credits
       */
      allowOverages: boolean;
      /**
       * Maximum credits the company can go negative. Null = unlimited.
       */
      maxOveragesCredits?: number | null;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Updated allow overages setting
       */
      allowOverages?: boolean;
      /**
       * Maximum credits the company can go negative. Null = unlimited.
       */
      maxOveragesCredits?: number | null;
    };
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/processes/companyCredits/allowOverages',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request — invalid body`,
        403: `Feature not enabled for this company`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Enable or disable invoiced billing for the company
   * @param requestBody
   * @returns any Invoiced billing setting updated successfully
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesCompanyCreditsInvoicedBilling(
    requestBody: {
      /**
       * Whether to enable invoiced billing (pay via invoice instead of credit card)
       */
      invoicedBilling: boolean;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Updated invoiced billing setting
       */
      invoicedBilling?: boolean;
    };
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/companyCredits/invoicedBilling',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request — invoicedBilling must be a boolean`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * List saved payment methods for the company
   * @returns any Payment methods retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsPaymentMethods(): CancelablePromise<{
    data?: {
      paymentMethods?: Array<{
        id?: string;
        brand?: string;
        last4?: string;
        expMonth?: number;
        expYear?: number;
      }>;
      defaultPaymentMethodId?: string | null;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/paymentMethods',
      errors: {
        500: `Internal server error`,
      },
    });
  }

  /**
   * Create a Stripe SetupIntent for saving a new payment method
   * @returns any SetupIntent created successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompanyCreditsPaymentMethodsSetupIntent(): CancelablePromise<{
    data?: {
      /**
       * Stripe client secret for SetupIntent confirmation
       */
      clientSecret?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companyCredits/paymentMethods/setupIntent',
      errors: {
        500: `Internal server error`,
      },
    });
  }

  /**
   * Remove a saved payment method
   * @param paymentMethodId Stripe payment method ID to remove
   * @returns any Payment method removed successfully
   * @throws ApiError
   */
  public deleteApiServiceorganizationsProcessesCompanyCreditsPaymentMethods(
    paymentMethodId: string,
  ): CancelablePromise<{
    data?: {
      removed?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/processes/companyCredits/paymentMethods/{paymentMethodId}',
      path: {
        'paymentMethodId': paymentMethodId,
      },
      errors: {
        400: `Bad request — no Stripe customer or method not found`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Set a payment method as the default for off-session charges
   * @param requestBody
   * @returns any Default payment method updated successfully
   * @throws ApiError
   */
  public putApiServiceorganizationsProcessesCompanyCreditsPaymentMethodsDefault(
    requestBody?: {
      /**
       * Stripe payment method ID to set as default
       */
      paymentMethodId: string;
    },
  ): CancelablePromise<{
    data?: {
      defaultPaymentMethodId?: string;
    };
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/processes/companyCredits/paymentMethods/default',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request — no Stripe customer or method not found`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Get auto top-up configuration for the company
   * @returns any Auto top-up configuration retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsAutoTopUp(): CancelablePromise<{
    data?: {
      /**
       * Auto top-up configuration, or null if not configured
       */
      autoTopUp?: Record<string, any> | null;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/autoTopUp',
      errors: {
        500: `Internal server error`,
      },
    });
  }

  /**
   * Create or update auto top-up configuration for the company
   * @param requestBody
   * @returns any Auto top-up configuration updated successfully
   * @throws ApiError
   */
  public putApiServiceorganizationsProcessesCompanyCreditsAutoTopUp(
    requestBody?: {
      /**
       * Whether auto top-up is enabled
       */
      enabled: boolean;
      /**
       * Top up when balance falls below this number of credits
       */
      threshold: number;
      /**
       * Which credit pack to auto-purchase
       */
      packSku: '5000' | '15000' | '50000' | '100' | '900' | '1500';
      /**
       * Maximum amount in cents that may be auto-charged in a calendar month
       */
      monthlySpendCapCents: number;
    },
  ): CancelablePromise<{
    data?: {
      /**
       * Updated auto top-up configuration
       */
      autoTopUp?: Record<string, any>;
    };
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/processes/companyCredits/autoTopUp',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request — validation error or not eligible for auto top-up`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Submit a dispute for a DEBIT billing event
   * @param requestBody
   * @returns any Dispute submitted successfully
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompanyCreditsDisputes(
    requestBody: {
      /**
       * UUID of the billing event to dispute
       */
      billingEventUuid: string;
      /**
       * Reason for the dispute. Must be at least 10 words.
       */
      reason: string;
    },
  ): CancelablePromise<{
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companyCredits/disputes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request — only DEBIT events can be disputed`,
        404: `Billing event not found`,
        409: `A dispute already exists for this charge`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * List disputes submitted by the current company
   * @returns any Disputes retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCompanyCreditsDisputes(): CancelablePromise<{
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/companyCredits/disputes',
      errors: {
        500: `Internal server error`,
      },
    });
  }

}
